<template>
  <div class="home_page">
    <!-- 头部 -->
    <header>
      <div class="header_content w_d">
        <!-- 左 -->
        <div class="header_l">
          <img src="@/assets/images/项目成果首页03/logo.png" alt="" />
          <div class="logo_title">
            <h3>中小学教师信息技术应用能力提升工程2.0</h3>
            <p>项目成果共建共享平台</p>
          </div>
        </div>
        <!-- 中 -->
        <div class="header_c">
          <ul>
            <li
              v-for="(item, index) in listArr"
              :key="index"
              :class="{ licurrent: index == liCurrent }"
              @click="triggerTabs(index, item.path)"
              class="pointer pass_hand"
            >
              {{ item.title }}
              <div class="line" v-if="index == liCurrent"></div>
            </li>
          </ul>
        </div>
        <!-- 右 -->
        <el-dropdown @command="clickMenuItem" class="pass_hand">
          <div class="header_r">
            <img
              v-if="webUserInfo.headportrait_url"
              :src="webUserInfo.headportrait_url"
              alt=""
            />
            <img
              v-else
              src="../../assets/images/xxx项目类别成果（微能力类）/教师管理@3x.png"
              alt=""
            />
            <span>{{ webUserInfo.realname }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in personArr"
              :key="index"
              :command="item.id"
              v-show="item.isOk"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <!-- 面包屑 -->
    <MyBreadCrumb
      v-if="
        ($route.path !== '/areahome' && $route.matched.length <= 2) ||
        $route.meta.target == 'only'
      "
    ></MyBreadCrumb>
    <!-- 主要内容 -->
    <router-view></router-view>
    <!-- <MainContent></MainContent> -->
    <!-- 底部 -->
    <footer>
      <div class="footer_tlan">
        <div class="footer_t w_d">
          <img
            class="footer_logo"
            src="../../assets/images/项目成果首页03/logo.png"
            alt=""
          />
          <div class="qr_code" v-if="false">
            <img src="@/assets/images/项目成果首页03/微信客服.png" alt="" />
            <p>华南师范微信客服</p>
            <h3>4008-876-381</h3>
          </div>
          <dl class="z_serve">
            <dt>专业服务</dt>
            <dd>培训项目</dd>
            <dd>课程超市</dd>
            <dd>资源中心</dd>
          </dl>
          <dl>
            <dt>关于我们</dt>
            <dd>华南师范创客教育</dd>
            <dd>教师职称申报辅导</dd>
            <dd>名师网络工作室</dd>
          </dl>
          <dl class="contact" v-if="false">
            <dt>联系我们</dt>
            <dd class="serve_email">客服邮箱：ycpxkfb@163.com</dd>
          </dl>
        </div>
      </div>
      <div class="footer_b">
        <p>
          华南师范大学 版权所有 粤ICP备05008875号|Copyright © 2021 South China
          Normal University. All Rights Reserved
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import MainContent from "./main_content/MainContent";
export default {
  data() {
    return {
      // 头部文子
      listArr: [
        { title: "首页", path: "/areahome" },
        { title: "全员项目成果", path: "/allstaffproject" },
        { title: "示范项目成果", path: "/demonstrateproject" },
        { title: "示范课堂", path: "/demonstratecourse" },
      ],
      liCurrent: 0, // 当前的li
      webUserInfo: {}, // 用户信息
      personArr: [
        { name: "个人中心", id: 1, isOk: true },
        { name: "个人资料", id: 3, isOk: true },
        { name: "修改密码", id: 4, isOk: true },
        { name: "退出登录", id: 2, isOk: true },
      ],
    };
  },
  methods: {
    // 切换头部tabs
    triggerTabs(index, path) {
      //   this.liCurrent = index;
      this.$router.push(path);
    },
    // 点击菜单项
    clickMenuItem(id) {
      // 跳到个人中心
      if (id == 1) {
        // 1教师 2校培 3县培 4市培 5校管理员
        let role = this.webUserInfo.role;
        // 能力类型 0无 1微能力 2非微能力
        let ability_type = this.webUserInfo.ability_type;
        // 教师
        if (role == 1) {
          // 微能力教师
          if (ability_type == 1) {
            // 首次进入个人中心的默认路径
            this.$router.push("/abilityEvaluaList");
            // 非微能力教师
          } else if (ability_type == 2) {
            // 首次进入个人中心的默认路径
            this.$router.push("/abilityEvaluaList");
          }
          // 校培
        } else if (role == 2) {
          this.$router.push("/schooltraindeclare");
          // 县培
        } else if (role == 3) {
          this.$router.push("/areatrainabilitydclare");
          // 市培
        } else if (role == 4) {
          this.$router.push("/areatrainabilitydclare");
          // 校管理员
        } else if (role == 5) {
          // this.$router.push("/schoolmnghome");
          this.$router.push("/abilityevaluation");
        } else {
          this.$message.warning(
            "您的账号还未参加任何学习或教学，请找管理员添加！"
          );
        }
      } // 退出登录
      else if (id == 2) {
        this.$confirm("您确定要退出登录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            localStorage.removeItem("webUserInfo");
            // localStorage.clear();
            setTimeout(() => {
              this.$router.push("/login");
            }, 1000);
          })
          .catch(() => {});
      } else if (id == 3) {
        this.$router.push({
          path: "/userData",
        });
      } else if (id == 4) {
        this.$router.push({
          path: "/setPassword",
        });
      }
    },
  },
  watch: {
    // 控制tab的选中状态
    $route(val) {
      console.log(val, "184");
      if (val.name == "AreaHome") {
        this.liCurrent = 0;
      } else if (val.name == "AllStaffProject") {
        this.liCurrent = 1;
      } else if (val.name == "DemonstrateProject") {
        this.liCurrent = 2;
      } else if (val.name == "DemonstrateCourse") {
        this.liCurrent = 3;
      } else {
        this.liCurrent = 4;
      }
      // 存储当前状态，页面刷新时使用
      localStorage.setItem("liCurrent", this.liCurrent);
    },
  },
  created() {
    // 获取用户信息
    let webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
    // 判断线上域名
    // if (webUserInfo.hostOpen == false) {
    //   this.personArr.forEach((item) => {
    //     if (item.id == 3 || item.id == 4) {
    //       item.isOk = false;
    //     }
    //   });
    // }
    // 获取存储的状态
    let liCurrent = JSON.parse(localStorage.getItem("liCurrent"));
    if (liCurrent) {
      this.liCurrent = liCurrent;
    }
    if (webUserInfo) {
      this.webUserInfo = webUserInfo;
    }
  },
  components: {
    MainContent,
  },
};
</script>
 
<style lang = "less" scoped>
.home_page {
  /* 头部 */
  header {
    box-shadow: 0 4px 7px 0 #f5f5f5;
    .header_content {
      height: 64px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /* 左 */
      .header_l {
        display: flex;
        flex: 3;
        img {
          display: block;
          width: 50px;
        }
        .logo_title {
          margin-left: 20px;
          h3 {
            font-weight: 700;
            font-size: 14px;
            padding-top: 4px;
          }
          p {
            font-size: 12px;
            padding-top: 5px;
          }
        }
      }
      /* 中 */
      .header_c {
        flex: 5;
        ul {
          display: flex;
          li {
            height: 64px;
            line-height: 60px;
            margin-right: 70px;
            position: relative;
            font-size: 16px;
            .line {
              position: absolute;
              background-color: #fa8c15;
              color: #fff;
              font-weight: 600;
              width: 100%;
              height: 3px;
              bottom: 16px;
            }
          }
          .licurrent {
            color: #fa8c15;
            font-weight: 600;
          }
        }
      }
      /* 右 */
      .header_r {
        img {
          margin-right: 10px;
          vertical-align: middle;
          width: 34px;
          height: 34px;
          border-radius: 50%;
        }
      }
    }
  }

  /* 底部 */
  footer {
    background-color: #ececec;
    .footer_tlan {
      height: 238px;
      .footer_t {
        display: flex;
        color: #999;
        padding-top: 40px;
        .footer_logo {
          width: 152px;
          height: 158px;
          display: block;
          margin: 0 204px;
        }
        .qr_code {
          text-align: center;
          > img {
            width: 85px;
            height: 85px;
          }
          p {
            padding: 15px 0 17px 0;
          }
          h3 {
            color: #ff7e24;
            font-size: 18px;
            font-weight: 700;
          }
        }
        .z_serve {
          margin: 0 144px 0 203px;
        }
        .contact {
          margin-left: 92px;
        }
        dl {
          dt {
            font-size: 16px;
            color: #333;
            font-weight: 600;
            height: 55px;
          }
          dd {
            height: 35px;
          }
          .serve_email {
            color: #ff7e24;
          }
        }
      }
    }
    .footer_b {
      height: 50px;
      background-color: #000b1d;
      line-height: 50px;
      p {
        text-align: center;
        color: #fff;
      }
    }
  }
}
</style>